import React from 'react';

function Footer() {
  return (
    <footer className="footer" style={{background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)', color: '#1e293b', padding: '60px 0 30px 0'}}>
      <div className="container">
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 250px), 1fr))', gap: '40px', marginBottom: '40px', alignItems: 'center'}}>
          <div>
            <h3 style={{fontSize: '1.5rem', marginBottom: '20px', fontWeight: 700, color: '#1e293b'}}>Bethel Public School</h3>
            <p style={{opacity: 0.9, lineHeight: 1.6, color: '#1e293b'}}>"Rooted in Values, Growing in Knowledge."</p>
          </div>
          
          <div style={{textAlign: 'center'}}>
            <h4 style={{fontSize: '1.2rem', marginBottom: '15px', fontWeight: 600, color: '#1e293b'}}>Follow Us</h4>
            <div style={{display: 'flex', gap: '15px', justifyContent: 'center', alignItems: 'center'}}>
              <a href="https://www.youtube.com/@bethelonline7627" target="_blank" rel="noopener noreferrer" style={{background: '#ff0000', width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'transform 0.3s', flexShrink: 0}}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <i className="fab fa-youtube" style={{color: 'white', fontSize: '1.8rem'}}></i>
              </a>
              <a href="https://www.facebook.com/BethelPublicSchool/" target="_blank" rel="noopener noreferrer" style={{background: '#1877f2', width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'transform 0.3s', flexShrink: 0}}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <i className="fab fa-facebook-f" style={{color: 'white', fontSize: '1.8rem'}}></i>
              </a>
            </div>
          </div>
          
          <div style={{textAlign: window.innerWidth <= 768 ? 'center' : 'right'}}>
            <h4 style={{fontSize: '1.2rem', marginBottom: '15px', fontWeight: 600, color: '#1e293b'}}>In Partnership With</h4>
            <img src="/images/logo-full-dark.160ebe4.png" alt="Vista's Learning" style={{height: 'auto', maxWidth: window.innerWidth <= 480 ? '100px' : window.innerWidth <= 768 ? '120px' : '50px', width: '100%', objectFit: 'contain'}} />
          </div>
        </div>
        
        <div style={{borderTop: '1px solid rgba(30, 41, 59, 0.2)', paddingTop: '20px', textAlign: 'center'}}>
          <p style={{color: '#1e293b'}}>&copy; {new Date().getFullYear()} Bethel Public School. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
